<template>
  <svg width="72" height="72" xmlns="http://www.w3.org/2000/svg">
    <g fill-rule="nonzero" fill="none">
      <path fill="#6BCFFF" d="M44 34h6l-3-4zM44 38h6l-3 4z" />
      <path d="M27 24h6v24h-6a1 1 0 0 1-1-1V25a1 1 0 0 1 1-1z" fill="#2F75FF" />
      <path d="M35 24h6a1 1 0 0 1 1 1v22a1 1 0 0 1-1 1h-6V24z" fill="#FFC760" />
    </g>
  </svg>
</template>
